// components/IconSelect.jsx
import React from "react";
import { TextField, MenuItem } from "@mui/material";
import * as MuiIcons from "@mui/icons-material";

const iconList = [
    "ListAlt", "DynamicFeed", "VideoLibrary",
    "Description", "Code", "Link", "Assignment", "Article", "LibraryBooks", "Slideshow"
];

const IconSelect = ({ value, onChange, label = "Icon", fullWidth = true }) => {
    return (
        <TextField
            select
            label={label}
            fullWidth={fullWidth}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            variant="outlined"
            size="medium"
            InputProps={{
                sx: {
                    minHeight: "45px",
                },
            }}
        >
            {iconList.map((icon) => (
                <MenuItem key={icon} value={icon}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center", width: "100%" }}>
                        {MuiIcons[icon] && React.createElement(MuiIcons[icon], { fontSize: "small" })}
                    </div>
                </MenuItem>
            ))}
        </TextField>
    );
};

export default IconSelect;